module.exports =
  VISIBILITY_ALL: 'VISIBILITY_ALL'
  VISIBILITY_UNREAD: 'VISIBILITY_UNREAD'



// WEBPACK FOOTER //
// ./app/scripts/views/notification/visibility-states.coffee